import { Link } from "react-router-dom";
import { MapPin, Phone, ArrowUpRight } from "lucide-react";
import { NAV_LINKS, COMPANY } from "../data/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-obsidian">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
      <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <img
            src="/assets/ltec-logo-navbar.png"
            alt="LTEC — Leo Tidwell Excavating Corp. Underground Utilities"
            data-testid="footer-logo"
            className="h-20 w-auto mb-6"
          />
          <p className="font-display text-3xl sm:text-4xl font-extrabold uppercase leading-none text-white">
            Built Beneath
            <span className="block text-brand-light">California.</span>
          </p>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-400">
            {COMPANY.name} — {COMPANY.years} years of underground utility construction,
            horizontal directional drilling, and auger boring across California, Nevada & Arizona.
          </p>
          <p className="mt-6 font-mono text-xs uppercase tracking-[0.2em] text-slate-500">
            {COMPANY.license}
          </p>
        </div>
        <nav aria-label="Footer">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">Site</p>
          <ul className="mt-4 space-y-2.5">
            {NAV_LINKS.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  data-testid={`footer-link-${link.name.toLowerCase()}`}
                  className="group inline-flex items-center gap-1 text-sm text-slate-300 transition-colors hover:text-white"
                >
                  {link.name}
                  <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-opacity group-hover:opacity-100" />
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">Headquarters</p>
          <ul className="mt-4 space-y-3 text-sm text-slate-300">
            <li className="flex items-start gap-2.5">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-light" />
              <span data-testid="footer-address">{COMPANY.address}</span>
            </li>
            <li className="flex items-start gap-2.5">
              <Phone className="mt-0.5 h-4 w-4 shrink-0 text-brand-light" />
              <a
                href={COMPANY.phoneHref}
                data-testid="footer-phone"
                className="transition-colors hover:text-white"
              >
                {COMPANY.phone}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
          &copy; {new Date().getFullYear()} {COMPANY.name}
        </p>
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-600">
          Telephone &middot; Power &middot; Fiber &middot; Gas
        </p>
      </div>
    </div>
  </footer>
);
